import { render } from "./TheFooter.vue?vue&type=template&id=33616861&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=33616861&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33616861"]])

export default __exports__